import React from "react";
import { Icon } from "../Icon";

export function GlobalSearch({ placeholder = "Buscar empleados, equipos, documentos…" }) {
  return (
    <div
      role="search"
      title="Próximamente"
      style={{
        flexShrink: 0,
        width: 320,
        height: 32,
        border: "1px solid var(--kr-border)",
        borderRadius: 6,
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "0 10px",
        fontSize: 12,
        color: "var(--kr-fg-subtle)",
        background: "var(--kr-neutral-50)",
        cursor: "not-allowed",
      }}
    >
      <Icon name="Search" size={14} style={{ color: "var(--kr-fg-muted)" }} />
      <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {placeholder}
      </span>
      <span
        style={{
          fontFamily: "var(--kr-font-mono)",
          fontSize: 10,
          padding: "1px 5px",
          borderRadius: 4,
          background: "var(--kr-bg-surface)",
          border: "1px solid var(--kr-border)",
          color: "var(--kr-fg-muted)",
        }}
      >
        ⌘ K
      </span>
    </div>
  );
}

export default GlobalSearch;
